import classNames from 'classnames/bind';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import * as styles from './Button.css';
import { dt } from '../../../helpers/Utils/GetTailwindToken';

const cx = classNames.bind(styles);

/**
 * Button component to standardize the styling and html structure of any button component on the page
 * This supports "buttonType: type of button" such as default, primary or others ; "size :size of button" (large, small and Extra Small)
 * */

const BUTTON_SIZES = ['Default', 'Xl', 'Lg', 'Md', 'Sm'];

const BUTTON_TYPES = ['Default', 'Primary', 'PrimaryAlt', 'Secondary', 'Tertiary', 'Text', 'Link'];

const BUTTON = ['submit', 'button', 'linkbutton'];

class Button extends Component {
    /**
     * Supported React properties
     * @type {Object}
     */
    static propTypes = {
        size: PropTypes.oneOf(BUTTON_SIZES),
        buttonType: PropTypes.oneOf(BUTTON_TYPES),
        type: PropTypes.oneOf(BUTTON),
        className: PropTypes.string,
        buttonId: PropTypes.string,
        onClick: PropTypes.func,
        onMouseDown: PropTypes.func,
        children: PropTypes.node,
        isDisabled: PropTypes.bool,
        automationId: PropTypes.string,
        onBlur: PropTypes.func,
        ellipsis: PropTypes.bool,
        linkUrl: PropTypes.string,
        target: PropTypes.string,
    };

    /** @properties {Default set up} */
    static defaultProps = {
        buttonType: 'Default',
        size: 'Default',
        type: 'button',
        className: '',
        buttonId: '',
        onClick: null,
        onMouseDown: null,
        children: null,
        isDisabled: false,
        automationId: 'at-button-default-id',
        onBlur: null,
        ellipsis: false,
        linkUrl: '',
        target: '',
    };

    /**
     * Renders the basic outer skeleton required to render the button
     * @return {ReactComponent}
     * {children} is used to pass icons (span or svg) and button value
     */
    render() {
        const {
            className,
            children,
            size,
            buttonType,
            type,
            onClick,
            onMouseDown,
            isDisabled,
            automationId,
            onBlur,
            ellipsis,
            buttonId,
            linkUrl = '',
            target = '',
        } = this.props;

        const btnStyle = dt([
            'text-white',
            'text-center',
            'rounded-md',
            'min-w-[120px]',
            'pt-2',
            'active:text-gray-70',
            'disabled:bg-opacity-50',
            'disabled:cursor-default',
            'font-open-sans-semibold',
        ]);

        const ellipsisStyle = dt(['whitespace-nowrap', 'overflow-ellipsis', 'overflow-hidden']);

        const buttonClass = cx(
            'btn',
            size ? `btn${size}` : null,
            `btn${buttonType}`,
            className,
            ellipsis ? ellipsisStyle : '',
            btnStyle
        );

        // Entire ReactDOM
        return type && type === 'linkbutton' ? (
            <a
                href={linkUrl}
                onClick={onClick}
                className={buttonClass}
                data-automation-id={automationId}
                target={target}
            >
                {children}
            </a>
        ) : (
            <button
                data-automation-id={automationId}
                disabled={isDisabled}
                id={buttonId}
                type={type}
                onBlur={onBlur}
                onClick={onClick}
                onMouseDown={onMouseDown}
                className={buttonClass}
            >
                {children}
            </button>
        );
    }
}
export default Button;
